import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../store/auth-context";
import { bookAppointmentService } from "../../services/bookAppointment.service";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Snackbar,
  TextField,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import TeleAppointmentBooked from "./TeleAppointmentBooked";
import { teleconsulationService } from "../../services/teleconsult.service";
import { useTranslation } from "react-i18next";
import CloseIcon from "@material-ui/icons/Close";

function BookTeleAppointments(props: any) {
  const [beginDate, setBeginDate] = useState<any>(
    new Date().toISOString().slice(0, 10)
  );
  const [t] = useTranslation();
  const [morningSlots, setMorningSlot] = useState<any>([]);
  const [afternoonSlots, setAfternoonSlot] = useState<any>([]);
  const [eveningSlots, setEveningSlot] = useState<any>([]);
  const [timeSlot, setTime] = useState<any>("");
  const [patientName, setPatientName] = useState<any>("");
  const [timeItem, setTimeItem] = useState<any>("");
  const authCtx = useContext(AuthContext);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("");
  const [appointmentBookedModal, setAppointBookedModal] =
    useState<boolean>(false);
  const [isValidUser, setIsValidUser] = useState<boolean>(true);
  const [bookingConfirmation, setBookingConfirmation] =
    useState<boolean>(false);
  const [dateList, setDateList] = useState<any>([]);

  const [apptRefNumber, setAppointmentRefNo] = useState<string>("");
  const [comment, setComment] = useState<string>("");
  const [timeSlotErrorMessage, setTimeSlotErrorMessage] = useState<string>("");

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const doctorValue = props.doctorDetails;
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const brandName = localStorage.getItem("brandName");

  useEffect(() => {
    const fetchTime = () => {
      fetchTimeSlot();
    };
    fetchTime();

    // eslint-disable-next-line
  }, [beginDate]);

  useEffect(() => {
    getDateList();
    // eslint-disable-next-line
  }, []);

  const handleDateChange = (e: any) => {
    setBeginDate(e.target.value);
    setTime("");
  };

  const fetchTimeSlot = async () => {
    authCtx.toggleLoader(true);
    const patientRecord = JSON.parse(
      localStorage.getItem("getPatientRecord") || "{}"
    );
    let timeData: any = {};
    timeData = {
      facilityId: doctorValue.locationId,

      department: doctorValue.department_code,

      physicianLicense: doctorValue.physician_code,

      physicianNo: doctorValue.physician_number,

      providerLicence: "",

      beginDate: beginDate,

      endDate: "",
      patientId:
        Object.keys(patientRecord).length !== 0 &&
        patientRecord[0].patientId[0] !== ""
          ? patientRecord[0].patientId[0]
          : "",
    };
    // authCtx.toggleLoader(false);

    let result = await teleconsulationService.getTimeSlot(timeData);
    if (result && result.status === 500) {
      console.log(result.message);
    } else {
      if (
        result &&
        result.morningSlots.length === 0 &&
        result.afternoonSlots.length === 0 &&
        result.eveningSlots.length === 0 &&
        result.message &&
        result.message.message &&
        result.message.message[0] ===
          "Please call on +971-80055 for booking an appointment."
      ) {
        setTimeSlotErrorMessage(
          t("Please call on +971-80055 for booking an appointment.")
        );
      } else if (
        result.morningSlots.length >= 0 &&
        result.afternoonSlots.length >= 0 &&
        result.eveningSlots.length >= 0
      ) {
        setMorningSlot(result.morningSlots);
        setAfternoonSlot(result.afternoonSlots);
        setEveningSlot(result.eveningSlots);
        setTimeSlotErrorMessage("");
      }
    }

    authCtx.toggleLoader(false);
  };

  const hanldeTimeChange = (e: any, timeItem: any) => {
    setTime(e.target.value);
    setTimeItem(timeItem);
  };

  function validationForm() {
    let isValid = true;
    // if (comment === "") {
    //   setCommenterror(true);
    //   setCommentErrorText("Please enter a reason for teleconsultation");
    //   isValid = false;
    // }
    return isValid;
  }

  const confirmBooking = async () => {
    let data: any;
    if (props.familyMemberId !== 0 && props.familyMemberId !== null) {
      let familMember = props.familyMemberList.find(
        (item: any) => item.familyMemberId === props.familyMemberId
      );
      if (familMember.age > 18) {
        if (
          familMember.mobile === user.mobile &&
          familMember.callingCode === user.callingCode
        ) {
          setShowModal(true);
          setModalType("error");
          setModalText(
            t(
              "As per our privacy policies an adult requires a different number. Please use a different number."
            )
          );
          setIsValidUser(false);
        }
      }
    }

    if (validationForm()) {
      if (isValidUser) {
        authCtx.toggleLoader(true);
        data = {
          facilityId: doctorValue.locationId,

          apptDate: timeItem.date,
          apptStartTime: timeItem.startTime,
          apptEndTime: timeItem.endTime,
          patientId: user.userId,
          familyMemberId: props.familyMemberId,
          callpoint: "",
          department: timeItem.department,
          physicianNo: timeItem.physicianNo,
          physicianLicense: timeItem.physicianLicense,
          scheduleType: "TELEMED",
          comment: comment,
          title: "Mr",
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          dateOfBirth: "",
          genderId: 0,
          identityNumber: "",
          mobileNo: user.mobile,
          nationality: "",
          countryId: user.countryCode,
          documentTypeId: 0,
          identityDocExpiryDate: "",
          patientLang: "",
          occupation: "",
          bloodGroup: "",
          externalPatientId: "",
          country: "",
          city: "",
          region: "",
          streetNumber: "",
          postOfficeBox: "",
          kinFirstName: "",
          kinLastName: "",
          kinCountry: "",
          kinTelephone: "",
          kinRelationship: "",
          apptType: props.selectedPaymentMode,
        };
        const response = await teleconsulationService.bookAppointmentForTele(
          data
        );
        authCtx.toggleLoader(false);
        if (response && response.data && response.data.appointmentRefNo) {
          setAppointmentRefNo(response.data.appointmentRefNo);
          setAppointBookedModal(true);
          if (props.familyMemberId === 0) {
            localStorage.setItem("isPatientRecordCall", "false");
          }
        } else {
          if (
            response &&
            response.message &&
            response.message.message &&
            response.message.status[0] === "E"
          ) {
            handleShow();
            setModalText(response.message.message[0]);
            setModalType("error");
            setTimeout(() => {
              setModalText("");
              handleClose();
            }, 5000);
          } else if (
            response.errorResponse &&
            response.errorResponse.data.error &&
            response.errorResponse.data.error.detail
          ) {
            handleShow();
            setModalText(
              response.errorResponse && response.errorResponse.data.error.detail
            );
            setModalType("error");
            setTimeout(() => {
              setModalText("");
              handleClose();
            }, 5000);
          } else {
            handleShow();
            setModalText(t("Something went wrong!"));
            setModalType("error");
            setTimeout(() => {
              setModalText("");
              handleClose();
            }, 5000);
          }
        }
      }
    }
  };

  const getDateList = () => {
    const dateArray = [];
    for (let i = 0; i < 7; i++) {
      let date = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() + i
      );
      dateArray.push({
        value: new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1)
          .toISOString()
          .slice(0, 10),
        name: new Date(date).toLocaleDateString("en-UK", {
          weekday: "short",
          day: "2-digit",
          year: "numeric",
          month: "short",
        }),
      });
    }
    setDateList(dateArray);
  };

  return (
    <>
      <div className="mt-3" key={"select-slot-start"}>
        <p className="fs-18 fw-600" key="select-patient-1">
          {t("Select Date & Time")}
        </p>
        <div className="mt-1">
          {dateList &&
            dateList.length > 0 &&
            dateList.map((item: any, index: any) => (
              <>
                <input
                  key={item.name}
                  type="radio"
                  className="btn-check no-focus"
                  name="Date"
                  id={"date" + index}
                  value={item.value}
                  checked={beginDate === item.value}
                  onChange={(e) => handleDateChange(e)}
                />

                <label
                  key={item.value}
                  className="btn btn-outline-primary btn-xs me-2 mb-1 me-1 fs-12 no-focus"
                  htmlFor={"date" + index}
                  dir="ltr"
                >
                  {item.name}
                </label>
              </>
            ))}{" "}
        </div>
        {timeSlotErrorMessage ? (
          <div className="text-999 mt-4">
            <i className="material-icons-outlined fs-3 me-2">info</i>
            <span className="position-relative t-n10">
              {t(timeSlotErrorMessage)}
            </span>
          </div>
        ) : (
          <>
            <div className="fs-12 mt-4">
              <div className="mb-3">
                <h6 className="fs-14 fw-bold">{t("Morning Slot")}</h6>
                {morningSlots && morningSlots.length > 0 ? (
                  morningSlots.map((timeItem: any, index: any) => (
                    <>
                      <input
                        key={index}
                        type="radio"
                        className="btn-check no-focus"
                        name="Morning"
                        id={"morning" + index}
                        value={timeItem.text}
                        checked={timeSlot === timeItem.text}
                        onChange={(e) => hanldeTimeChange(e, timeItem)}
                      />

                      <label
                        key={"morning" + index}
                        className="btn btn-outline-primary btn-xs mb-1 me-1 fs-12 w-150 no-focus"
                        htmlFor={"morning" + index}
                        dir="ltr"
                      >
                        {timeItem.text}
                      </label>
                    </>
                  ))
                ) : (
                  <>
                    <div className="text-999">
                      <i className="material-icons-outlined fs-3 me-2">info</i>
                      <span className="position-relative t-n10">
                        {t("No Available Slot")}
                      </span>
                    </div>
                  </>
                )}
              </div>
              <div className="mb-3">
                <h6 className="fs-14 fw-bold">{t("Afternoon Slot")}</h6>
                {afternoonSlots && afternoonSlots.length > 0 ? (
                  afternoonSlots.map((timeItem: any, index: any) => (
                    <>
                      <input
                        key={index}
                        type="radio"
                        className="btn-check no-focus"
                        name="Afternoon"
                        id={"afternoon" + index}
                        value={timeItem.text}
                        checked={timeSlot === timeItem.text}
                        onChange={(e) => hanldeTimeChange(e, timeItem)}
                      />

                      <label
                        key={"afternoon" + index}
                        className="btn btn-outline-primary btn-xs mb-1 me-1 fs-12 w-150 no-focus"
                        htmlFor={"afternoon" + index}
                        dir="ltr"
                      >
                        {timeItem.text}
                      </label>
                    </>
                  ))
                ) : (
                  <>
                    <div className="text-999">
                      <i className="material-icons-outlined fs-3 me-2">info</i>
                      <span className="position-relative t-n10">
                        {t("No Available Slot")}
                      </span>
                    </div>
                  </>
                )}
              </div>
              <div className="mb-3">
                <h6 className="fs-14 fw-bold">{t("Evening Slot")}</h6>
                {eveningSlots && eveningSlots.length > 0 ? (
                  eveningSlots.map((timeItem: any, index: any) => (
                    <>
                      <input
                        key={index}
                        type="radio"
                        className="btn-check no-focus"
                        name="Evening"
                        id={"evening" + index}
                        value={timeItem.text}
                        checked={timeSlot === timeItem.text}
                        onChange={(e) => hanldeTimeChange(e, timeItem)}
                      />

                      <label
                        key={"evening" + index}
                        className="btn btn-outline-primary btn-xs mb-1 me-1 fs-12 w-150 no-focus"
                        htmlFor={"evening" + index}
                        dir="ltr"
                      >
                        {timeItem.text}
                      </label>
                    </>
                  ))
                ) : (
                  <>
                    <div className="text-999">
                      <i className="material-icons-outlined fs-3 me-2">info</i>
                      <span className="position-relative t-n10">
                        {t("No Available Slot")}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
            <button
              className="btn btn-primary px-5 no-focus btn-primary-linear"
              onClick={(e) => setBookingConfirmation(true)}
              disabled={timeSlot === ""}
            >
              {t("Proceed")}
            </button>
          </>
        )}
      </div>

      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={appointmentBookedModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <TeleAppointmentBooked
            apptRefNumber={apptRefNumber}
            doctorName={doctorValue.name}
            patientName={props.patientName}
            apptDate={beginDate}
            apptTime={timeSlot}
            selectedPaymentMode={props.selectedPaymentMode}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={bookingConfirmation}
        fullWidth={true}
        onClose={() => setBookingConfirmation(false)}
        maxWidth="md"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          <IconButton
            className="float-end p-1"
            aria-label="close"
            onClick={() => setBookingConfirmation(false)}
          >
            <CloseIcon />
          </IconButton>
          <h4 className="fw-bold d-inline-block">{t("Confirmation")}</h4>
          <h5 className="">
            {t("Please review booking details before booking")}
          </h5>
        </DialogTitle>
        <DialogContent>
          <div className="p-2 bg-lightgray">
            <div className="d-flex justify-content-between align-items-center border-bottom">
              <p className="fw-bold fs-18">{t("Appointment with")}</p>
              <p className="">{doctorValue.name}</p>
            </div>
            <div className="d-flex justify-content-between align-items-center border-bottom">
              <p className="fw-bold fs-18">{t("Patient Name")}</p>
              <p className="">{props.patientName}</p>
            </div>
            <div className="d-flex justify-content-between align-items-center border-bottom">
              <p className="fw-bold fs-18">{t("Appointment Date")}</p>
              <p className="">{beginDate}</p>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <p className="fw-bold fs-18">{t("Appointment Time")}</p>
              <p className="">{timeSlot}</p>
            </div>
          </div>
        </DialogContent>
        <DialogActions className="mx-2">
          <button
            className="btn btn-primary mr-auto px-5 no-focus btn-primary-linear"
            onClick={confirmBooking}
          >
            {t("Confirm")}
          </button>
        </DialogActions>
      </Dialog>

      {modalType === "error" && (
        <Snackbar
          open={showModal}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
      {modalType === "success" && (
        <Snackbar
          open={showModal}
          onClose={() => {
            handleClose();
            setModalText("");
          }}
        >
          <Alert onClose={handleClose} severity="success">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default BookTeleAppointments;
